import { BookingInfoPageModule } from './booking-info/booking-info.module';
import { CalendarSettingsPageModule } from './calendar-settings/calendar-settings.module';
import { VideoArchivesSettingsPageModule } from './video-archives-settings/video-archives-settings.module';
import { MusicSettingsPageModule } from './music-settings/music-settings.module';
import { SpecialsSettingsPageModule } from './specials-settings/specials-settings.module';
import { AccountInfoPageModule } from './account-info/account-info.module';
import { PrimaryInfoPageModule } from './primary-info/primary-info.module';
import { ContactInfoPageModule } from './contact-info/contact-info.module';
import { GallerySettingsPageModule } from './gallery-settings/gallery-settings.module';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ProfileSettingsPageRoutingModule } from './profile-settings-routing.module';

import { ProfileSettingsPage } from './profile-settings.page';



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ProfileSettingsPageRoutingModule,
    AccountInfoPageModule,
    PrimaryInfoPageModule,
    ContactInfoPageModule,
    GallerySettingsPageModule,
    SpecialsSettingsPageModule,
    MusicSettingsPageModule,
    VideoArchivesSettingsPageModule,
    CalendarSettingsPageModule,
    BookingInfoPageModule
  ],
  declarations: [ProfileSettingsPage]
})
export class ProfileSettingsPageModule {}
